import moment from "moment-jalaali";
import LayoutConfig from "../../Config/layoutConfig";

const TravellerItem = (props) => {
    const { traveller, fillPassengerInformation, openDeleteConfirm } = props;

    let passengerName = traveller.firstname + " " + traveller.lastname
    if (props.isHotel && traveller.firstnamePersian && traveller.lastnamePersian) {
        passengerName = traveller.firstnamePersian + " " + traveller.lastnamePersian
    }
    
  const isStyle3 = LayoutConfig.themeClassName === 'style-3';

    return (
        <tr>
            <td> {passengerName}</td>
            <td> {traveller.gender ? "مرد" : "زن"} </td>
            <td> {traveller.nationalId || traveller.passportNumber} </td>
            {!props.isHotel && <td> {traveller.passportExpirationDate ? moment(traveller.passportExpirationDate).format("YYYY/MM/DD") : "--"} </td>}
            <td> {traveller.birthDate ? moment(traveller.birthDate).format("YYYY/MM/DD") : "--"} </td>
            <td>
                <button
                    type="button"
                    className="button blue-btn small-btn min-w-55"
                    onClick={() => { fillPassengerInformation(traveller) }}
                >
                    انتخاب
                </button>

                <button
                    type="button"
                    className={`button small-btn min-w-55 margin-start-light ${isStyle3?"purple-border-btn":"red-btn"}`}
                    onClick={() => { openDeleteConfirm(traveller.id) }}
                >
                    حذف
                </button>

            </td>
        </tr>
    )
}

export default TravellerItem;